export const app = {
  loading: '只今処理中、しばらくお待ちください。',
  title: '輸入物流システム',
  manu: 'メニュー',
  master: 'マスター',
  home: 'ホーム',
  system: {
    error: '未知エラーが発生しましたので、IT担当に問い合わせください。',
  },
  buttons: {
    search: '検索',
    new: '新規',
    paidNew: '有償新規',
    unpaidNew: '無償新規',
    add: '追加',
    edit: '編集',
    remove: '削除',
    confirm: '修正',
    back: '戻る',
    csvExport: 'CSV出力',
    csvUpload: 'excelアップロード',
    save: '保存',
    temporarySave: '一時保存',
    poDetect: 'P/O で検出',
    ivUpload: 'I/V アップロード',
    addFreeItems: '無償商品登録行追加',
    addPackages: 'P/L登録',
    plUpload: 'P/L アップロード',
    sytcIvCsvUpload: 'SYTC I/V excelアップロード', // ----
    skuUpload: '品番アップロード',
    split: '行分け',
    cancelSplit: '行分け取り消し',
    splitPackage: 'P/L 行分け',
    apply: '使用',
    send: '確定送信',
    fileUpload: '書類アップロード',
    toNew: '参照新規作成',
    openEta: 'ETA修正',
    updateContainer: 'コンテナ情報一括登録',
    abolitionAndCancel: 'キャンセル',
    reset: 'リセット',
    poExport: 'P/OデータCSV出力',
    ivExport: 'I/V作成用CSV出力',
    export: '出力',
    docDownload: '資料ダウンロード',
    downloadNow: 'ダウンロード',
    videoTutorial: 'マニュアルビデオDL',
  },
  labels: {
    company: { name: '企業名称' },
    partner: '海外取引先',
    ivNo: 'I/V NO',
    poNo: 'P/O NO',
    lotNo: 'Lot NO',
    blNo: 'B/L NO',
    masterBlNo: 'Master B/L NO',
    houseBlNo: 'House B/L NO',
    loadingPort: '積出港',
    classification: '部品区分',
    transportMode: '輸送形態',
    scWarehouse: '最終納入場所',
    warehouseKeeper: '納入場所担当者',
    dischargePort: '陸揚港',
    incoterm: '建値',
    stackType: '積み方',
    etd: 'ETD',
    eta: 'ETA',
    creationDate: 'I/V作成日',
    createDate: 'P/O発行日',
    currencyCode: '外貨',
    productionDate: '生産年月',
    canSelect: '出力可項目',
    selected: '選定項目',
    currency: '通貨',
    grandTotal: 'I/V金額',
    unit: '単位',
    chargeUnit: '計上単位',
    qty: '数量',
    price: '小計価格',
    status: '状態',
    invoice: {
      item: {
        origin: '原産地',
        unitPrice: 'FOB単価',
      },
    },
    division: '区分',
    invType: 'I/V 区分',
    totalAmount: '合計金額',
    warehouse: '納入場所',
    package: {
      flag: '識別番号',
      cartonStartNo: 'Carton Start No', // --
      cartonEndNo: 'Carton End No', // --
      perCartonQty: '入り数',
      netWeight: 'N/W',
      grossWeight: 'G/W',
      volume: 'M3',
      containerNo: 'CONTAINER NO',
      containerSize: 'CONTAINER SIZE',
      totalQty: 'QTY',
      shippedCarton: 'SHIPPED CARTON',
      unitPrice: '単価',
    },
    bu: {
      name: '事業本部',
    },
    department: {
      name: '事業部',
    },
    skuCode: '社内品番',
    productCode: '品種',
    skuSupplierCode: '社外品番',
    siNo: 'SI.NO',
    shippingAdvice: {
      requestDate: '依頼日',
      blIssueDate: 'B/L発行日',
      exportCustomsClearanceDate: '輸出通関日',
    },
    forwarder: '船社・航空会社',
    shipName: '本船名',
    volNo: 'Vol NO',
    customsAgent: '通関業者',
    forecastDeliveryDate: '納入予定日',
    sjlWarehouseName: '納入予定場所',
    sort: {
      none: '無',
      asc: '昇り順',
      desc: '下り順',
    },
    ctnNo: 'コンテナNO',
    an: 'フレイトインボイス',
    group: 'グループ',
    forecastAcceptanceDate: '受入予定日',
    downloadAttach: '添付資料ダウンロード',
  },
  validator: {
    messages: {
      required: '必要である',
      lessThanEight: 'INV.Noは10桁以内でご記入ください。',
      illegalInput: '禁止入力内容があります。',
    },
  },
  messages: {
    sendConfirm: 'SA確定送信してよろしいでしょうか？',
    removeSuccess: '削除成功しました。', //削除済。
    removeConfirm: '削除してよろしいでしょうか？',
    saveSuccess: '保存が完了しました。', //保存済。
    saveApplicationSuccess: '申込完了しました。',
    resetSuccess:
      'ETA・本船名の情報を修正すると、当初登録した納入予定日が例外期間になる場合、各担当者へメール送信されます。ご了承ください。', //リセット成功
    fail: '失敗！',
    sent: '{type}送信済',
    errors: {
      title: 'エラー',
      exchangeRateNotFound:
        '為替レートが登録されていませんので、計算できません。SJL担当に連絡ください',
      pricingNotFound:
        '{chargeItem}費用単価が登録されていませんので、計算できません。SJL担当に連絡ください。',
      devanPricingRepeat:
        '該当サプライヤと納入場所のデバン料が既に存在しているので、保存できません。（課金単位はper container、M3から一つのみ選べます。）',
      freightChargeNotCalculated: '海上・航空運賃計算まだ完了していません',
      insuranceRateNotFound:
        '保険費レートが登録されていませんので、計算できません。SJL担当に連絡ください。',
      taxRateNotFound:
        '消費税税率が登録されていませんので、計算できません。SJL担当に連絡ください。',
      commissionRateNotFound:
        'SJLコミッションが登録されていませんので、計算できません。SJL担当に連絡ください。',
      consumptionTaxDateIllegal: '消費税税率時間設定が正しくありません',

      exchangeRateNotFoundForQuotation:
        '為替レートが登録されていませんので、見積計算できません。SJL担当に連絡ください',
      pricingNotFoundForQuotation:
        '{chargeItem}費用単価が登録されていませんので、見積計算できません。SJL担当に連絡ください。',
      insuranceRateNotFoundForQuotation:
        '保険費レートが登録されていませんので、見積計算できません。SJL担当に連絡ください。',
      taxRateNotFoundForQuotation:
        '消費税税率が登録されていませんので、見積計算できません。SJL担当に連絡ください。',
      commissionRateNotFoundForQuotation:
        'SJLコミッションが登録されていませんので、見積計算できません。SJL担当に連絡ください。',

      handWriteOffDataNotIllegal: '手動消込が失敗しました。',
    },
    warning: {
      title: '警告',
    },
    success: {
      title: '',
    },
    alert: {
      // common
      select_one: '一つのレコードをチェックしてください。', //请勾选一条数据
      deleting: '削除して宜しいでしょうか？', //削除可以吗
      delete_success: '削除完了',
      save_success: '保存完了',
      mail_success: '送信完了',
      save_draft: '一時保存完了',

      //見積
      quotation_success: '見積計算完了',
      quotation_mailed: '見積書（依頼）メール送信完了',

      //納入指示依頼メール配信
      cancel_confriming: '送信解除して宜しいでしょうか？', // 確定解除吗？
      cancel_confirmed: '送信解除完了',
      //納入指示
      select_ge2: '二つ以上のレコードをチェックしてください。',

      confirmed: '確定完了',
    },
  },
  warehouseTypes: [
    {
      value: 'SJL',
      text: 'SJL納入場所',
    },
    {
      value: 'SC',
      text: 'SC納入場所',
    },
  ],
  screenStatisticTypes: [
    {
      value: '海上運賃',
      text: '海上運賃',
    },
    {
      value: 'アジショナルチャージ',
      text: 'アジショナルチャージ',
    },
    {
      value: '国内運賃',
      text: '国内運賃',
    },
    {
      value: '国内諸掛',
      text: '国内諸掛',
    },
    {
      value: '商品代金',
      text: '商品代金',
    },
    {
      value: 'SJL Commission',
      text: 'SJL Commission',
    },
    {
      value: '保険費',
      text: '保険費',
    },
    {
      value: '搬出手数料',
      text: '搬出手数料',
    },
    {
      value: '取扱料',
      text: '取扱料',
    },
    {
      value: '通関料',
      text: '通関料',
    },
    {
      value: 'CC.FEE',
      text: 'CC.FEE',
    },
  ],
  finalWarehouseTypes: [
    {
      value: '11',
      text: '最終納入場所単価マスタ登録可',
    },
    {
      value: '10',
      text: '最終納入場所単価マスタ登録不可',
    },
    {
      value: '01',
      text: '最終納入場所対象外単価マスタ登録可',
    },
  ],
  unPackingObjs: [
    {
      value: '対象',
      text: '対象',
    },
    {
      value: '対象外',
      text: '対象外',
    },
  ],
  weekdays: '日,月,火,水,木,金,土'.split(','),
}
export const M0010 = {
  title: 'ユーザーマスタ検索',
}

export const B200 = {
  messages: {
    quotationSuccess: '見積済',
  },
}

export const B0300 = {
  titles: [
    'INV P/L登録',
    'INVOICE 基本情報',
    'INVOICE 詳細',
    'Package List詳細',
    '無償商品登録行追加',
    'P/O で検出',
  ],
  buttons: {
    download: 'INV・PL出力',
  },
  messages: {
    errors: {
      checkTotal: '{poNo}の合計数が最大数より大きい.',
      ivNoExist: 'INV番号はすでに存在しています。', //請求書番号はすでに存在しています
      hugeQty: 'PO残数が足りません。', //既存の数量を越えてしまいました。
      invalidQty: '0未満または{qty}を超えて保存しないでください',
      duplicatePO: 'このPOはすでに存在しています。', //'PO重複',
      invalidItem: 'PO情報はブランクのため、再度のご確認を願います。', //請求書の詳細を空にすることはできません!
      invalidPacking:
        'パッキングリスト情報はブランクのため、再度のご確認を願います。', //'パッキングリストの詳細は空にできません!',
      invalidInvoiceItemQty: '{po}の数が最大数を超えています!',
      invalidPackageQty:
        'P/L行分けの総数量は元のパッケージ総数量を超えてしまいました。',
      notFullyPackaged:
        'INVOICE詳細に登録するPOがPackage List詳細に引用されないものがあります。ご確認お願いします。',

      buDifferent: 'Invoiceに複数事業本部のPOが入れられません。',
      qtyNotMatch:
        'PO出荷数量とPOのPackingList数量が不一致のため、保存できません。',
      nw_gw_m3_require:
        'P/L詳細の容積重量が0値となっているP/Oがあるため、保存ができません',
      carton_require: 'Carton Infoを入力してください。',
      nw_gw_m3_gt0: 'N/W,G/W,M3をゼロより大きい値を入力してください',
      per_carton_qty_invalid:
        'PackingListのPO数量の計算結果が間違いましたので、再度ご確認ください。（入数＊carton数＝数量）',
      paysit_not_unique: 'すべてのpaymentが一致しなければなりません。',
      no_product: '品種が存在していません',
      per_carton_qty_integer: '入数が整数ではないですので、再修正ください。',
      partner_unique: '海外取引先が異なっているため、追加できません。',
      po_not_found_upload: 'あるPOデータは存在しません。',
    },
    warning: {
      existPackagedPO: 'このPOがすでに梱包されました。', //'すでに梱包されたPOがあります'
    },
  },
  labels: {
    qty: '商品の数',
    incoterm: '支払い条件',
    po: {
      qty: '発注数',
      leftInvoice: '発行残',
    },
  },
}
export const B0400 = {
  titles: [
    'Shipping Advice',
    '運送情報',
    'INV P/L情報',
    'CONTAINER NO',
    'ETA修正',
    'I/V List',
    'SJLへ送信',
    '納入送信画面へ',
  ],
  title: 'S/A登録',
  messages: {
    modifyEta:
      'ETA・本船名の情報を修正すると、納入予定日・納入予定場所の情報がリセットされるので、よろしいでしょうか？',
    errors: {
      invalidPort:
        'S/Aの積出港・陸揚港とINVの積出港・陸揚港が不一致のため、再度確認してください',
      invalidBlNo: '重複B/L No.が存在します。', //B/L No. 繰り返すことはできません
      invalidContainerInfo: 'INV P/L情報が不整備です、ご確認お願いします。',
      invalidInvoice: '該当INVは既に存在しています。',

      package_qty_over: 'インボイスの数量と不一致です。',
      do_confirmed: 'DO確定済のため、該当SAが修正不可です。',
      package_required: 'パッケージを追加してください',
      ctn_no_save_type_diff:
        'は同一の場合、コンテナサイズが一致しなければならない。',
      per_carton_qty_invalid:
        'PackingListのPO数量の計算結果が間違いましたので、再度ご確認ください。（入数＊carton数＝数量）', //「入数＊carton数＝数量」ルールを守ってください。
      nw_gw_m3_require: 'N/W G/W M3が必須入力項目です。ご確認ください。',
      nw_gw_m3_gt0: 'N/W,G/W,M3をゼロより大きい値を入力してください。',
      sa_status_invalid: 'S/A取消してください。',
      inv_canceled: 'I/V取消してください',
      do_not_relieve: 'DO解除していない、或いはDO解除確認していない',
      paysit_not_unique: '全てのPOの支払う日付は一致しなければならない',
      pay_inv_require: '有償INVが無いと、SAを作成できません。',
      source_conflict: 'SAPからのINVはPFからのINVと同一SAへ作成できません',
      inv_bu_unique: 'Invoiceに複数事業本部のPOが入れられません',
      m3_more_than_100:
        'Ｍ３が異常値(１００Ｍ３以上)となっていますので、正しいか確認ください。',
    },
    success: {
      sendSuccess: 'SA送信成功しました。', //SA送信済
      completed: '完了しました',

      cancel_success: '取消成功しました。',
    },
  },
  labels: {
    flightNo: 'フライトNO',
    voyageNo: 'VOYAGE NO',
    siNo: 'S/I NO',
  },
}

export const B0500 = {
  messages: {
    error:
      '発注者がユーザーＩＤに存在しないため、メールが送信されませんでした。該当のPOは次の階段に進めませんでした。',
  },
}

export const B0800 = {
  messages: {
    noPattern: '先に配送パターンのご確認を願いします。',
    noChargeConfirm: '先にDO費用のご確認を願いします。',
    doConfirmed: '該当DOが確認済です。',
    doRelieving: '該当DOが解除申請中のため、DO確定できません。',
    doNoEmpty: 'DO.NOが無いと、DO確定できません。',
    blNoDuplicate: 'BL No.は重複している、ご確認ください。',
    exchangeRateNotFound:
      '為替レートが登録されていませんので、計算できません。SJL担当に連絡ください。',
    productNotFound: '品番は品種情報がない',
    noWhsManager: '送信先は存在しない、担当者設定してから再送信してください。',
    doSuccessConfirm: 'D/O確定が完了しました。',
    noFreightCharge: 'フレイト費用を計算しないと、DO確定できません。',
    unableRelieve: '未確定のDOは解除できません。',
    relieveSuccess: 'DO解除確認が完了しました。', //DO解除済
    select_one: '一つのレコードを選んでください。', //'一つのD/Oデータをチェックしてください。',
    unableRelieveConfirm: '該当DOが解除申請中のため、DO確定できません。', //'DO解除申請をしないと、DO解除確認できません'
  },
}

export const B1000 = {
  messages: {
    errors: {
      doHasConfirmed: 'DO確定済みのため、変更不可です。',
    },
  },
}

export const B1300 = {
  title: 'ステータス照会',
  buttons: {
    eiaj: '機種別諸掛',
    eta: 'ETA１週間経過',
    sytc: '着荷計画書',
    warehouseCtn: '倉庫別コンテナ本数',
    byMonth: '搬入预定表（月別）',
    mother: 'D/O親単位表示',
    child: 'D/O枝番単位表示',
  },
  labels: {
    status: 'ステータス',
    warehousingDate: '最新納入指示日',
    operatorId: '担当者ID',
    ctnSize: 'コンテナ サイズ',
    warehousingTime: '納入指示時間',
    forecastDeliveryTime: '最新納入時間',
    finallyWarehouseName: '納入場所',
    drakeCompanyName: 'ドレージ手配',
    date1: '売上処理日',
    date2: '買掛処理日',
    branchCode: '枝番',
  },
}

export const B1500 = {
  title: 'P/O照会',
  labels: {
    status: 'ステータス',
    isLeftInvoice: 'INV作成残あり',
    leftInvoice: 'INV作成残',
    qty: '発注数量',
    unitPrice: '発注単価',
    subTotal: '発注金額',
    finishedQty: 'S/A済数',
    createdInvoice: 'INV作成済',
    leftSupply: '納入残数',
    orderName: '発注者氏名',
  },
  messages: {
    errors: {
      checkLeftInvoice: '出力POのINV作成残がゼロのため、出力できません。',
      hasDifBu: '複数事業本部のPOが存在してあるので出力できません。',
    },
  },
}

export const menus = {
  M0010: 'ユーザー',
  M0020: '権限',
  M0030: '企業',
  M0040: '部所（事業本部、事業部）',
  M0050: '計上単位',
  M0060: '建値（支払条件）',
  M0070: '地域',
  M0080: '港',
  M0090: '納入場所',
  M0100: '為替レート',
  M0110: 'コンテナ種別',
  M0120: 'チャージトラック種別',
  M0130: '費用単価（タリフ）',
  M0140: '保険費レート',
  M0150: '通関費用',
  M0160: '品番',
  M0230: '品種',
  M0170: '納入場所グループ',
  M0180: '運送形態',
  M0190: '消費税税率',
  M0200: '国内配送パターン',
  M0210: '基本コミッション',
  M0220: '費用項目',
  M0240: 'Special',
  M0250: 'その他諸掛',
  M0260: '船社別フリータイム一覧',
  M0270: '品種グループ',
  M0280: '稼働年月',
  M0290: '倉庫別コンテナ受入枠',
  M0300: 'ロングドレー判定テーブル',

  B0300: 'INV P/L登録',
  B0400: 'S/A登録',
  B1600: 'BL確認完了送信',
  B0500: '納入指示メール配信',
  B0600: '納入指示',
  B0700: '受入確認',
  B1000: 'フレイトI/V作成',
  B0800: 'D/O確定',
  B0900: 'EIAJ',
  B1100: '諸掛費用登録',
  B1200: '月次処理・請求',
  B1201: '月次処理・請求',
  B1400: '売掛金回収',
  B1601: 'BL確認完了照会',
  B2000: '月次運賃ハンド対応一覧',
  B2100: '純無償請求書',
  B2200: '事前仮予約',
  B2300: '倉庫別予約一覧',
  B2400: '海外請求書発行',
  // B1800: 'PO変更・取消一覧',
  // B1900: 'PreSA・本SA相違一覧',
}

export const bizException = {
  PRICE_MUST_VALID_GROUP: '通貨はブランクですので、DO確定できません',
  NGW_MUST_VALID_GROUP:
    'DO単位のNW/GW/M3はブランク、”0”、SA単位より大きいですので、DO確定できません',
}
export const tdoc = {
  INVOICE_NO_IS_EXITS发票号已存在: 'INV.NO重複で登録できません。',
  BILL_NO_DATE_IS_EXITS提单号与日期组合已存在: 'BL NOとBL DATE重複しています。ご確認お願いします。',
  BILL_NO_DATE_IS_REPEAT提单号与日期组合重复: 'BL NOとBL DATE重複しています。ご確認お願いします。',
  MD5_NOT_EQUAL:
    'BLデータはSAPから上書きされました、検索してから編集お願いします。',
}

export const auth = {
  ACCOUNT_CANNOT_BE_USED: 'アカウント使えません', //已验证
  ACCOUNT_HAS_EXPIRE: 'アカウントは既に有効期限を切れて、使えなくなっています', //需要等过期了才能验证
  USER_STATUS_IS_REQUIRED: 'ユーザーステータスを入力してください', //应该不会出现
  EFFECTIVE_TIME_IS_REQUIRED: '発効日を入力してください', //已验证
  10003: '有効期限を入力してください', //已验证
  EFFECTIVE_TIME_MUST_BEFORE_EXPIRE_TIME:
    '発効日は有効期限を超えてはいけません。', //已验证
  EXPIRE_TIME_MUST_AFTER_NOW: '有効期限は本日以降の日付に設定してください。', //已验证
  USERNAME_REPEATED: 'ユーザー名が重複になっています', //username不会重复，所以邮箱不会重复,不会出现
  EMAIL_REPEATED: 'メールアドレスが重複になっています', //username不会重复，所以邮箱不会重复,不会出现
  ERROR_USER_OR_PASSWORD: 'ユーザー名またはパスワードが間違っています',
  PHONE_USED: '携帯番号は既に登録されています', //应该不会出现（不传）
  PHONE_NOT_NULL: '携帯番号を入力してください', //应该不会出现（不传）
  ILLEGAL_PHONE_NUMBER_PATTERN: '携帯番号の入力方式が正しくありません', //应该不会出现（不传）
  ILLEGAL_PASSWORD_PATTERN: 'パスワードの書式  最小12桁、最大20桁まで、少なくとも一つの大文字、小文字、数字と特殊記号を含む必要があります。', //已验证
  USER_REAL_NAME_NOT_NULL: '名前を入力してください', //已验证
  USER_REAL_NAME_FORMAT_INVALID:
    '名前の書式は正しくありません（書式：漢字、英語とスペース、頭文字は漢字と英語しか使えなく、長さは50文字を超えてはいけません）', //已验证
  USER_NAME_NOT_NULL: 'ユーザー名を入力してください', //不会出现空的
  USER_NAME_FORMAT_INVALID:
    'ユーザー名の書式は正しくありません（書式：英語、数字、スラッシュ“/”、アンダーバー”_”、セミコロン”.，”、長さは64桁を超えてはいけません、メールアドレスの書式も利用可能です）', //不会出现空的
  USER_LANGUAGE_NOT_NULL: '言語を選んでください', //不会出现
  USER_SAME_PASSWORD_RESET_EXCEPTION:
    '新パスワードは旧パスワードと重複してはいけません。', //已验证
  USER_EMAIL_IS_NULL: 'ユーザーメールアドレスを入力してください', //不会出现空的
  ILLEGAL_EMAIL_PATTERN: 'メールアドレスの入力方式が正しくありません', //不会出现，格式默认固定的
  OTHER: 'その他エラー', //已验证
}
